/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Network_Vehicle_Sort_ActivityInputs */

const fr_network_vehicle_sort_activity = /** @type {(inputs: Network_Vehicle_Sort_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activité`)
};

const en_network_vehicle_sort_activity = /** @type {(inputs: Network_Vehicle_Sort_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activity`)
};

/**
* | output |
* | --- |
* | "Activity" |
*
* @param {Network_Vehicle_Sort_ActivityInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const network_vehicle_sort_activity = /** @type {((inputs?: Network_Vehicle_Sort_ActivityInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Network_Vehicle_Sort_ActivityInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_network_vehicle_sort_activity(inputs)
	return en_network_vehicle_sort_activity(inputs)
});